export default __webpack_public_path__ + "static/media/logo-side-detail.ecd8f446.png";